'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _STARTER, _PROFESSIONAL, _ENTERPRISE, _STARTER$PROFESSIONAL;

var _Editions = require('self-service-api/constants/Editions');

var _Terms = require('self-service-api/constants/Terms');

var _TermIds = require('self-service-api/constants/TermIds');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = (_STARTER$PROFESSIONAL = {}, _defineProperty(_STARTER$PROFESSIONAL, _Editions.STARTER, (_STARTER = {}, _defineProperty(_STARTER, _Terms.MONTHLY, _TermIds.MONTHLY_25_PERCENT_DISCOUNT), _defineProperty(_STARTER, _Terms.ANNUAL, _TermIds.ANNUAL_25_PERCENT_DISCOUNT), _STARTER)), _defineProperty(_STARTER$PROFESSIONAL, _Editions.PROFESSIONAL, (_PROFESSIONAL = {}, _defineProperty(_PROFESSIONAL, _Terms.MONTHLY, null), _defineProperty(_PROFESSIONAL, _Terms.ANNUAL, _TermIds.ANNUAL_25_PERCENT_DISCOUNT), _PROFESSIONAL)), _defineProperty(_STARTER$PROFESSIONAL, _Editions.ENTERPRISE, (_ENTERPRISE = {}, _defineProperty(_ENTERPRISE, _Terms.MONTHLY, null), _defineProperty(_ENTERPRISE, _Terms.ANNUAL, _TermIds.ANNUAL_25_PERCENT_DISCOUNT), _ENTERPRISE)), _STARTER$PROFESSIONAL);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/constants/GrowthSuiteEditionTermIdMap.js
// module id = 137
// module chunks = 3 4